import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeMillisToMinutesAndSeconds'
})
export class TimeMillisToMinutesAndSecondsPipe implements PipeTransform {

  transform(value) {
    if (value === '-') {
      return '-';
    }
    const minutes = (value / 1000) / 60;
    const seconds = (minutes % 1) * 60;
    return minutes.toFixed() + '\' ' + seconds.toFixed() + '"';
  }

}
